import * as Sentry from "@sentry/react";
import moment from 'moment';
import config from '../config';
import { notify } from "react-notify-toast";
// Plain module: t() must be called INSIDE the function, never at module scope, or the string
// would freeze at import time and stop following the language switch.
import { t } from "../i18n";
export const Timezone = "Europe/Warsaw";

export const where = (array, attribute, value, condition) => {
    switch(condition){
        case 'not_include':
            return array.filter( object => value.indexOf(object[attribute]) === -1)
        case 'include':
            return array.filter( object => value.indexOf(object[attribute]) > -1)
        case 'not_equal':
            return array.filter( object => object[attribute] !== value)
        default:
            return array.filter( object => object[attribute] === value)
    }
}

export const get = (atrribute, array) => {
    let out = []
    array.map( elem => {
        out.push(elem[atrribute])
        return false
    })
    return out
}

export const unique = function(array) {
    var arr = [];
    for(var i = 0; i < array.length; i++) {
        if(!arr.includes(array[i])) {
            arr.push(array[i]);
        }
    }
    return arr;
}

export const getWeek = (day, defaultFormat=false) => {
    const dateFormat = config.get('dateFormat');
    let firstDay = moment(day);
    if (defaultFormat) firstDay = firstDay.format(dateFormat);
    const week = [firstDay];
    while (week.length < 7) {
        let nextDay = moment(firstDay).add(week.length, 'days');
        if (defaultFormat) nextDay = nextDay.format(dateFormat);
        week.push(nextDay);
    }
    return week;
}

export const getObjectValue = (object, keys) => {
    keys = keys.replace(/\[(\w+)\]/g, '.$1');
    keys = keys.replace(/^\./, '');
    const keysArray = keys.split('.');
    keysArray.forEach(key => {
        if (key in object) {
            object = object[key];
        } else {
            return;
        }
    });
    return object;
}

export const capitalize = string => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const handleClickOutside = (event, ref, callback) => {
  if (ref.current && !ref.current.contains(event.target)) {
    callback({ display: false })
  }
}

export const changeCursorPosition = (e) => {
   if (e.target.name === "timefield clicked") return;
   e.target.setSelectionRange(0, 0);
   e.target.name = "timefield clicked";
};

export const handleDisplayTime = async (e, setStateCallback, dataType) => {
    await setStateCallback({ displayTimeField: true, timeFieldDataType: dataType });
    document.getElementById(e.target.name) && document.getElementById(e.target.name).click();
};

export const handleApiError = async (err, errorType) => {
    const status = err.response?.status;
    let message = t('toasts.unknownError');

    if (err.response?.data instanceof Blob) {
        try {
            const errorText = await err.response.data.text();
            message = errorText || message;
        } catch (parseError) {
            message = t('toasts.errorParseFailed');
        }
    } else {
        message = err.response?.data || message;
    }

    // `message` is backend-supplied prose whenever the response carried one, so it stays exactly
    // as delivered (BRR-871): only the frame around it is translated. The 409 branch shows that
    // backend text on its own, by design.
    if (status === 409) {
        notify.show(message, 'warning', 5000);
    } else if (status) {
        notify.show(t('toasts.apiError', { status, message }), 'warning', 5000);
    } else {
        // No response at all (network failure, CORS, timeout). There is no status to show, and
        // interpolating the old 'Error' placeholder read as "Błąd Error: ..." in Polish.
        notify.show(t('toasts.apiErrorNoStatus', { message }), 'warning', 5000);
    }
    console.error(err);
    Sentry.withScope((scope) => {
       scope.setLevel("error");
       scope.setExtra("response", err.response);
       Sentry.captureMessage(errorType || err);
    });
    return err;
};
